/*
 * 公用js
 */
import {
  statSign
} from '@/request/api' // 导入我们的api接口

let appId = ''

if (process.env.NODE_ENV == 'production') {
  appId = 'wx53930908d89fabaf'
} else {
  appId = 'wxcefc329d5e00a0b9'
}

//工具对象
window.tool = {
  appId: appId, // 微信appId
  mddIosLink: 'https://itunes.apple.com/cn/app/%E5%9F%8B%E5%A0%86%E5%A0%86/id1314769817?mt=8',
  mddAdrLink: 'http://download-1254361794.file.myqcloud.com/mdd1222_105_14_%E5%9F%8B%E5%A0%86%E5%A0%86%E5%AE%98%E6%96%B9_sign.apk',
  init: function () {
    this.wx = this.isWeixin()
    this.wb = this.isWeibo()
    this.ios = this.isiOS()
    this.adr = this.isAndroid()
    this.mdd = this.isMdd()
    this.isHarmony = this.isHarmonyFunc()
    this.pc = this.isPc()
    this.no_data = ['', "", null, 'null', undefined, 'undefined']
  },
  // 跳转类型转换 1
  redirectTypeToJumpType: function (redirectType, params = '') {
    let typeId = ''
    let routes = ''
    switch (redirectType) {
      case 0:
        break
      case 1:
        routes = `jumpType=${redirectType}`
        params ? routes += `&dataUid=${params}` : ''
        break
      case 2:
        routes = `jumpType=8`
        params ? routes += `&dataUid=${params}` : ''
        break
      case 3:
        routes = `jumpType=${redirectType}`
        params ? routes += `&dataUid=${encodeURIComponent(params)}` : ''
        break
      case 4:
        routes = `jumpType=${redirectType}`
        params ? routes += `&dataUid=${params}` : ''
        break
      case 5:
        routes = `jumpType=${redirectType}`
        params ? routes += `&dataUid=${params}` : ''
        break
      case 6:
        routes = `jumpType=${redirectType}`
        params ? routes += `&dataUid=${params}` : ''
        break
      case 7:
        routes = `jumpType=${redirectType}`
        params ? routes += `&dataUid=${params}` : ''
        break
      case 8:
        routes = `jumpType=10`
        params ? routes += `&dataUid=${params}` : ''
        break
      case 9:
        routes = `jumpType=13`
        params ? routes += `&dataUid=${params}` : ''
        break
      case 10:
        routes = `jumpType=19`
        params ? routes += `&dataUid=${params}` : ''
        break
      case 11:
        routes = `jumpType=12`
        params ? routes += `&dataUid=${params}` : ''
        break
      case 12:
        break
      case 13:
        break
      case 14:
        break
      case 15:
        break
      case 16:
        routes = `jumpType=21`
        params ? routes += `&dataUid=${params}` : ''
        break
      case 17:
        routes = `vip/pay`
        typeId = `-1,1019`
        break
      case 18:
        routes = `jumpType=14`
        params ? routes += `&dataUid=${params}` : ''
        break
      case 19:
        routes = `jumpType=15`
        params ? routes += `&dataUid=${params}` : ''
        break
      case 20:
        routes = `jumpType=16`
        params ? routes += `&dataUid=${params}` : ''
        break
      case 21:
        routes = `jumpType=17`
        params ? routes += `&dataUid=${params}` : ''
        break
      case 22:
        routes = `jumpType=18`
        params ? routes += `&dataUid=${params}` : ''
        break
      case 23:
        break
      case 24:
        break
      case 25:
        // 暂时不用做
        routes = `user/medal/detail`
        break
      case 26:
        routes = `points/mall`
        typeId = `-1,1011`
        break
      case 27:
        routes = `points/exchange/record`
        typeId = `-1,1005`
        break
      case 28:
        routes = `points/record`
        typeId = `-1,1014`
        break
      case 29:
        routes = `user/home`
        params ? routes += `?uuid=${params}` : ''
        typeId = `${params},1008`
        break
      case 30:
        routes = `task/center`
        params ? routes += `?taskGroupUuid=${params}` : ''
        typeId = `-1,1015`
        break
      case 31:
        // 关注公众号
        break
      case 32:
        routes = `user/setting`
        typeId = `-1,1029`
        break
      case 33:
        routes = `user/setting/interest`
        typeId = `-1,1028`
        break
      case 34:
        // 发布页
        break
      case 35:
        // 勋章
        routes = `user/medal`
        params ? routes += `?memberUuid=${params}` : ''
        typeId = `${params},1022`
        break
      case 36:
        // 分享 APP
        break
      case 37:
        routes = `task/center`
        params ? routes += `?taskGroupUuid=${params}` : ''
        typeId = `-1,1015`
        break
      case 38:
        routes = `points/mall/product/detail?uuid=${params}`
        typeId = `1003,${params}`
        break
      case 39:
        routes = 'user/vod?tab='
        params == 0 ? routes += 'single' : routes += 'packet'
        params == 0 ? typeId = `1,1030` : typeId = `2,1030`
        break
      case 40:
        routes = `web?url=${params}`
        typeId = `${params},1013`
        break
      case 42:
        routes = `youzan/mall?url=${params}`   
        typeId = `${params},1035`
		break
	  case 44:
	    routes = `other/app?scheme=${params}`   
	    typeId = `-1,1039`
		break
	  case 48:
		params = params && JSON.parse(params);
	    routes = `wxMiniProgram?originId=${params.originId}`
		if(params.path){
			routes = `${routes}&path=${params.path}`
		}
	    typeId = `${params.originId},1051`
		break
    }
    let r = {
      routes,
      typeId,
    }
    return r
  },
  // 跳转类型转换 2
  redirectTypeToGoType: function (redirectType, params = '') {
    let type = ''
    let typeId = ''
    switch (redirectType) {
      case 0:
        typeId = `-1,1000`
        break
      case 1:
        type = 0
        typeId = `${params},1007`
        break
      case 2:
        type = 2
        typeId = `${params},1004`
        break
      case 3:
        typeId = `${params},1013`
        break
      case 4:

        break
      case 5:
        type = 12
        typeId = `${params},1006`
        break
      case 6:

        break
      case 7:

        break
      case 8:
        type = 11
        typeId = `${params},1016`
        break
      case 9:
        type = 13
        typeId = `${params},1018`
        break
      case 10:

        break
      case 11:
        type = 14
        typeId = `${params},1009`
        break
      case 12:
        type = 22
        typeId = `${params},1008`
        break
      case 13:
        break
      case 14:
        type = 18
        typeId = `${params},1020`
        break
      case 15:
        type = 10
        typeId = `${params},1008`
        break
      case 16:
        break
      case 17:
        type = 17
        typeId = `${params},1019`
        break
      case 18:
        type = 19
        typeId = `${params},1001`
        break
      case 19:
        typeId = `${params},1002`
        break
      case 20:
        type = 20
        break
      case 21:

        break
      case 22:
        type = 21
        break
      case 23:
        break
      case 24:
        break
    }
    let r = {
      type,
      typeId,
    }
    return r
  },
  isWeixin: function () {
    var ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true
    } else {
      return false
    }
  },
  isiOS: function () {
    var ua = navigator.userAgent
    if (
      !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ||
      ua.toLowerCase().indexOf('ios') != -1
    ) {
      // 埋堆堆版本的判断
      return true
    } else {
      return false
    }
  },
  // 是否为鸿蒙
  isHarmonyFunc: function(){
    var ua = navigator.userAgent
    return /OpenHarmony|HUAWEI/i.test(ua.toLowerCase())
  }, 
  isAndroid: function () {
    // 安卓浏览判断,比较难,一般非ios即为安卓
    var ua = navigator.userAgent
    if (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) {
      return true
    } else {
      return false
    }
  },
  isMdd: function () {
    // 判断是否在埋堆堆客户端内
    var ua = navigator.userAgent.toLowerCase()
    if (ua.indexOf('mddios') != -1 || ua.indexOf('mddandroid') != -1 || ua.indexOf('mddharmony') != -1) {
      return true
    } else {
      return false
    }
  },
  isWeibo: function () {
    var ua = navigator.userAgent.toLowerCase()
    if (ua.indexOf('weibo') != -1) {
      return true
    } else {
      return false
    }
  },
  isPc: function () {
    var sUserAgent = navigator.userAgent.toLowerCase()
    var bIsIpad = sUserAgent.match(/ipad/i) == 'ipad'
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os'
    var bIsMidp = sUserAgent.match(/midp/i) == 'midp'
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4'
    var bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb'
    var bIsAndroid = sUserAgent.match(/android/i) == 'android'
    var bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce'
    var bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile'
    var bIsMdd = sUserAgent.indexOf('mdd') != -1 // 埋堆堆判断
    if (
      !(
        bIsIpad ||
        bIsIphoneOs ||
        bIsMidp ||
        bIsUc7 ||
        bIsUc ||
        bIsAndroid ||
        bIsCE ||
        bIsWM ||
        bIsMdd
      )
    ) {
      return true
    } else {
      return false
    }
  },
  isPhone: function (str) {
    return /^1[3|4|5|7|8][0-9]{9}$/.test(str)
  },
  isNum: function (str) {
    return /^[1-9]\d*$/.test(str)
  },
  isTrue: function (val) {
    return !(
      val == null ||
      val == 'null' ||
      val == undefined ||
      val == 'undefined' ||
      val == ''
    )
  },
  isEmpty: function (obj) {
    for (var key in obj) {
      return false
    }
    return true
  },
  //获取请求参数
  getParam: function (name) {
    // 用户单页面应用程序
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    if (window.location.hash.split('?')[1]) {
      var r = window.location.hash.split('?')[1].match(reg)
      if (r != null) return r[2]
      return null
    }
  },
  //读写网络cookie
  readCookie: function (key) {
    try {
      var arr = document.cookie.match(
        new RegExp('(^| )' + key + '=([^;]*)(;|$)')
      )
      if (arr !== null) return arr[2] ? unescape(arr[2]) : null
      return null
    } catch (e) {
      console.log('readCookie' + e)
      return null
    }
  },
  judgeBrand: function (sUserAgent) {
    var isIphone = sUserAgent.match(/iphone/i) == 'iphone'
    var isHuawei = sUserAgent.match(/huawei/i) == 'huawei'
    var isHonor = sUserAgent.match(/honor/i) == 'honor'
    var isOppo = sUserAgent.match(/oppo/i) == 'oppo'
    var isOppoR15 = sUserAgent.match(/pacm00/i) == 'pacm00'
    var isVivo = sUserAgent.match(/vivo/i) == 'vivo'
    var isXiaomi = sUserAgent.match(/mi\s/i) == 'mi '
    var isXiaomi2s = sUserAgent.match(/mix\s/i) == 'mix '
    var isRedmi = sUserAgent.match(/redmi/i) == 'redmi'
    var isSamsung = sUserAgent.match(/sm-/i) == 'sm-'

    if (isIphone) {
      return 'iphone'
    } else if (isHuawei || isHonor) {
      return 'huawei'
    } else if (isOppo || isOppoR15) {
      return 'oppo'
    } else if (isVivo) {
      return 'vivo'
    } else if (isXiaomi || isRedmi || isXiaomi2s) {
      return 'xiaomi'
    } else if (isSamsung) {
      return 'samsung'
    } else {
      return 'default'
    }
  },
  writeCookie: function (key, value) {
    try {
      var exp = new Date()
      exp.setTime(exp.getTime() + 30 * 24 * 60 * 60 * 1000)
      document.cookie =
        key +
        '=' +
        encodeURIComponent(value) +
        ';domain=bshapp.cn;expires=' +
        exp.toGMTString() +
        ';path=/;'
    } catch (e) {
      return false
    }
  },
  //本地存储
  setCookie: function (key, value) {
    //封装localStorage存储
    try {
      if (window.localStorage) {
        localStorage.setItem(key, value)
      } else {
        var exp = new Date()
        exp.setTime(exp.getTime() + 30 * 24 * 60 * 60 * 1000)
        document.cookie =
          key +
          '=' +
          encodeURIComponent(value) +
          ';expires=' +
          exp.toGMTString() +
          ';path=/;'
      }
    } catch (e) {
      return false
    }
  },
  getCookie: function (key) {
    try {
      if (window.localStorage) {
        return localStorage.getItem(key)
      } else {
        var arr = document.cookie.match(
          new RegExp('(^| )' + key + '=([^;]*)(;|$)')
        )
        if (arr != null) return decodeURIComponent(arr[2])
        return null
      }
    } catch (e) {
      return null
    }
  },
  debounce: function (fn, wait) {
    // 函数防抖
    let timer = null
    return function () {
      let context = this
      let args = arguments
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
      timer = setTimeout(function () {
        fn.apply(context, args)
      }, wait)
    }
  },
  throttle: function (fn, gapTime) {
    // 函数节流
    let _lastTime = null
    return function () {
      let _nowTime = +new Date()
      if (_nowTime - _lastTime > gapTime || !_lastTime) {
        fn()
        _lastTime = _nowTime
      }
    }
  },
  //埋点方法
  getstatSign: function (json) {
    let self = this
    let data1 = {
      category: tool.mdd ? 1 : 0,
      channel: '',
      create_time: Date.parse(new Date()),
      label: '-1',
      value: '-1',
    }
    data1.visit_ip = ''
    if (typeof returnCitySN!=="undefined") {
      data1.visit_ip = returnCitySN['cip']
    }
    let isWeb = /Android|webOS|iPhone|iPod|BlackBerry/i.test(
      navigator.userAgent
    );
    (data1.platform = isWeb ? (tool.ios ? 'ios' : 'Android') : 'pc')
    //为了数据的准确，需确保调用完mdd.getUserInfo并执行了回调，再执行打点useruuid
    const phone = localStorage.getItem('usermobile') || localStorage.getItem('num') 
    data1.user_id = localStorage.getItem('useruuid') || phone
    if (data1.user_id == '' || data1.user_id == null) {
      data1.user_id = localStorage.getItem('inituser')
    }
    for (let key in json) {
      data1[key] = json[key]
    }
    var timestamp = Date.parse(new Date())
    var data = {
      action: data1.action,
      category: data1.category,
      channel: data1.channel,
      create_time: data1.create_time,
      game_id: data1.game_id,
      label: data1.label,
      page: data1.page,
      platform: data1.platform,
      user_id: data1.user_id,
      value: data1.value,
      visit_ip: data1.visit_ip,
    }

    //TODO
    return statSign(data)
    // .then((response) => {
    //   var res = response.data
    //   if (response.code == 200) {
    //     // console.log(res)
    //   }
    // })
    // .catch((err) => {
    //   console.log(err)
    // })
  },

  //获取URL指定参数
  getUrlStr: function (name) {
    let reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
    if (reg.test(window.location.href)) {
      return decodeURIComponent(RegExp.$2.replace(/\+/g, " "))
    }
    return undefined
  },
}
tool.init()

// 埋堆堆App内接口对象
window.mdd = {
  // 获取版本名
  mddGetVersionName: function (fn) {
    if (typeof fn == 'function') {
      window.mddGetVersionNameCallback = fn
    }
    if (tool.isAndroid() || tool.isHarmonyFunc() ) {
      app.mddGetVersionName()
    } else if (tool.isiOS()) {
      if (window.webkit) {
        window.webkit.messageHandlers.mddGetVersionName.postMessage({})
      } else {
        mddGetVersionName()
      }
    }
  },
  VersionName: function (data) {
    localStorage.setItem('VersionName', data)
    //alert(JSON.stringify(data))
  },
  // 调用登录
  login: function (fn) {
    if (typeof fn == 'function') {
      window.loginCallback = fn
    }
    if (tool.isAndroid() || tool.isHarmonyFunc()) {
      app.mddLogin()
    } else if (tool.isiOS()) {
      if (window.webkit) {
        window.webkit.messageHandlers.mddLogin.postMessage({})
      } else {
        mddLogin()
      }
      //window.webkit.messageHandlers.mddLogin.postMessage({});
    }
  },
  // 登录的回调
  loginCallback: function (data) {
    //alert(JSON.stringify(data));
    if (data.status == 0) {
      console.log('登录成功')
      localStorage.setItem('useruuid', data.id)
      localStorage.setItem('usermobile', data.mobile)
      window.location.reload()
    } else {
      localStorage.removeItem('useruuid')
      localStorage.removeItem('usermobile')
      //localStorage.clear();
    }
  },
  // 调用分享
  // json: iconUrl:分享图标(https),title:标题,desc:描述,webUrl:分享的链接,回调函数中的data.status==0表示分享成功,其余表示失败
  share: function (json, fn) {
    if (typeof fn == 'function') {
      window.shareCallback = fn
    }
    var shareContent = JSON.stringify(json)
    if (tool.isAndroid() || tool.isHarmonyFunc()) {
      app.mddShare(shareContent)
    } else if (tool.isiOS()) {
      if (window.webkit) {
        window.webkit.messageHandlers.mddShare.postMessage(json)
      } else {
        mddShare(json)
      }
    }
  },
  // 获取用户信息
  // fn(data) data.status==0表示用户信息成功,否则表示未登录,id,nickname,mobile,iconurl
  getUserInfo: function (fn) {
    if (typeof fn == 'function') {
      window.infoCallback = fn
      if (tool.isiOS()) {
        window.loginCallback = fn
      }
    }
    if (tool.isAndroid() || tool.isHarmonyFunc()) {
      app.mddGetUserInfo() //例如获取用户资料
    } else if (tool.isiOS()) {
      if (window.webkit) {
        window.webkit.messageHandlers.mddGetUserInfo.postMessage({})
      } else {
        mddGetUserInfo()
      }
    }
  },
  // 获取用户信息的回调
  infoCallback: function (data) {
    if (data.status == 0) {
      localStorage.removeItem('useruuid')
      localStorage.removeItem('usermobile')

      localStorage.setItem('useruuid', data.id)
      localStorage.setItem('usermobile', data.mobile)
    } else {
      localStorage.removeItem('useruuid')
      localStorage.removeItem('usermobile')
    }
  },
  // 初始化用户信息，主要是为了打点
  initUserInfo: function () {
    var inituserCache = localStorage.getItem('inituser')
    if (inituserCache == null) {
      inituserCache = Math.random()
        .toString(36)
        .substr(2)
    }
    localStorage.setItem('inituser', inituserCache)
    if (tool.isMdd()) {
      //app内
      //调用app接口加载用户信息
      mdd.getUserInfo(mdd.infoCallback)
    }
  },
  // 消息提醒
  tip: function (msg) {
    var msgs = `{"msg": "${msg}"}`
    if (tool.isAndroid() || tool.isHarmonyFunc()) {
      app.mddShowTips(msgs)
    } else {
      msgs = JSON.parse(msgs)
      window.webkit.messageHandlers.mddShowTips.postMessage(msgs)
    }
  },
  // 跳转到指定的文章页面
  goto: function (uuid) {
    var json = {
      type: 0,
    }
    json.uuid = uuid
    json = JSON.stringify(json)
    if (tool.isAndroid() || tool.isHarmonyFunc()) {
      app.mddGoto(json)
    } else if (tool.isiOS()) {
      json = JSON.parse(json)
      window.webkit.messageHandlers.mddGoto.postMessage(json)
    }
  },
  // 打开新的网页窗口
  newweb: function (value) {
    let url = '{"url": "' + value + '"}'
    if (tool.isAndroid() || tool.isHarmonyFunc()) {
      app.mddOpenWeb(url)
    } else if (tool.isiOS()) {
      url = JSON.parse(url)
      window.webkit.messageHandlers.mddOpenWeb.postMessage(url)
    }
  },
  video: function (voduId) {
    let json = {
      voduId: voduId,
    }
    if (tool.ios) {
      window.webkit.messageHandlers.mddOpenVodVideo.postMessage(json)
    } else {
      json = JSON.stringify(json)
      app.mddOpenVodVideo(json)
    }
  },
  mddVipRecharge: function (data) {
    var reqData = JSON.stringify(data)
    if (tool.isAndroid() || tool.isHarmonyFunc()) {
      app.mddVipRecharge(reqData)
    } else if (tool.isiOS()) {
      if (window.webkit) {
        window.webkit.messageHandlers.mddVipRecharge.postMessage(data)
      } else {
        mddVipRecharge(reqData)
      }
    }
  },
  // 打开微信小程序
  openWXMiniProgram: function (id, programType) {
    var json = {
      originId: id,
      miniprogramType: programType,
    }
    json = JSON.stringify(json)
    if (tool.isAndroid() || tool.isHarmonyFunc()) {
      app.openWXMiniProgram(json)
    } else if (tool.isiOS()) {
      if (window.webkit) {
        json = JSON.parse(json)
        window.webkit.messageHandlers.openWXMiniProgram.postMessage(json)
      } else {
        openWXMiniProgram(json)
      }
    }
  },
  // 关闭页面
  mddFinishWeb: function () {
    if (tool.isAndroid() || tool.isHarmonyFunc()) {
      app.mddFinishWeb()
    } else if (tool.isiOS()) {
      if (window.webkit) {
        window.webkit.messageHandlers.mddFinishWeb.postMessage({})
      } else {
        mddFinishWeb()
      }
    }
  },
  // 根据类型跳转不同的页面
  appDeepLink: function (goType, uuid, autoType, postUuid) {
    var json = {
      type: goType,
    }
    json.uuid = uuid
    if (autoType) {
      json.autoType = autoType
      if (autoType == 3) {
        json.postUuid = postUuid
      }
    }
    json = JSON.stringify(json)
    if (tool.isAndroid() || tool.isHarmonyFunc()) {
      app.mddGoto(json)
    } else if (tool.isiOS()) {
      if (window.webkit) {
        json = JSON.parse(json)
        window.webkit.messageHandlers.mddGoto.postMessage(json)
      } else {
        mddGoto(json)
      }
    }
  },
  // 新版跳转
  mddJumpLink: function (route, params) {
    window.location.href = `mdd://com.tvbc.maiduidui/${route}?${params}`
  },
  // 分享图片
  shareImage: function (url) {
    var json = {
      imageUrls: url,
    }
    json = JSON.stringify(json)
    if (tool.isAndroid() || tool.isHarmonyFunc()) {
      app.mddShareImage(json)
    } else if (tool.isiOS()) {
      if (window.webkit) {
        json = JSON.parse(json)
        window.webkit.messageHandlers.mddShareImage.postMessage(json)
      } else {
        mddShareImage(json)
      }
    }
  },
  // 只正对ios,跳到 APP STORE 我的账户
  mddSkipAppStoreAccount: function (data) {
    alert(JSON.stringify(data))
    if (tool.isiOS()) {
      if (window.webkit) {
        window.webkit.messageHandlers.mddSkipAppStoreAccount.postMessage(data)
      } else {
        mddSkipAppStoreAccount(data)
      }
    }
  },
  // 获取直播间信息(3.9.50+)
  // fn(data) 获取直播间信息回调 liveUuid：直播间id anchorMemberUuid：主播id
  mddLiveInfo: function (fn) {
    if (typeof fn == 'function') {
      window.mddLiveInfoCallback = fn
    }
    if (tool.isAndroid() || tool.isHarmonyFunc()) {
      app.mddLiveInfo()
    } else if (tool.isiOS()) {
      if (window.webkit) {
        window.webkit.messageHandlers.mddLiveInfo.postMessage({})
      } else {
        mddLiveInfo()
      }
    }
  },
  //直播间半窗登录(3.9.50+)
  mddLoginDialog: function (fn) {
    if (typeof fn == 'function') {
      window.loginCallback = fn
    }
    if (tool.isAndroid() || tool.isHarmonyFunc()) {
      app.mddLoginDialog()
    } else if (tool.isiOS()) {
      if (window.webkit) {
        window.webkit.messageHandlers.mddLoginDialog.postMessage({})
      } else {
        mddLoginDialog()
      }
    }
  },

  mddRouter: function (url) {
    var json = {
      url: url,
    }
    json = JSON.stringify(json)
    if (tool.isAndroid() || tool.isHarmonyFunc()) {
      app.router(json)
    } else if (tool.isiOS()) {
      if (window.webkit) {
        json = JSON.parse(json)
        window.webkit.messageHandlers.router.postMessage(json)
      } else {
        router(json)
      }
    }
  },

  init: function () {
    mdd.initUserInfo()
  },
}
mdd.init()
